
import React, { HTMLAttributes } from 'react';

interface GlassCardProps extends HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  className?: string;
  hoverEffect?: boolean;
}

export const GlassCard: React.FC<GlassCardProps> = ({ children, className = '', hoverEffect = false, ...props }) => {
  return (
    <div className={`glass-card p-4 md:p-6 rounded-xl ${hoverEffect ? 'hover:shadow-2xl hover:shadow-white/5' : ''} ${className}`} {...props}>
      {children}
    </div>
  );
};
